import React, { useState } from "react";
import { GoArchive, GoBlocked, GoChecklist, GoDiff, GoMilestone, GoTasklist       } from "react-icons/go";
import { Link } from "react-router-dom";

const Sidebar = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const options = [
    { icon: <GoTasklist  />, label: "Corregir Alertas", route: "check-revision" },
    { icon: <GoBlocked />, label: "Agregar Regla", route: "add-rule" },
    { icon: <GoDiff  />, label: "Agregar Revisión", route: "add-revision" },
    { icon: <GoChecklist />, label: "Mis Correcciones", route: "my-revisions" },
    { icon: <GoArchive  />, label: "Historial Completo", route: "historical-revisions" },
    { icon: <GoMilestone />, label: "Ver Reglas", route: "all-rules" },
  ];

  return (
    <div className="w-64 bg-gray-800 text-white flex flex-col min-h-full">
      {/* Sidebar */}
      <div className="w-64 bg-gray-800 text-white flex flex-col">
        <ul className="flex-1">
          {options.map((option, index) => (
            <Link
              key={index}
              to={option.route}
              className={`flex items-center p-4 hover:bg-gray-700 cursor-pointer ${
                activeIndex === index ? "bg-gray-700" : ""
              }`}
              onClick={() => setActiveIndex(index)}
            >
                <span className="text-lg mr-3">{option.icon}</span>
                <span>{option.label}</span>
            </Link>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
